import { gql } from '__generated__';

export default gql(`
  query GetParticipantData($project_id: ID!, $participant_id: ID!) {
    project(id: $project_id) {
      id
      participant(id: $participant_id) {
        id
        email
        first_name
        last_name
        full_name
        locale
        active
        deactivated_at
        anonymized
        balance
        registration_summaries(include_inactive: true) {
          id
          active_registrations_count
          dashboard_url
          event {
            id
            title
            logo {
              id
              url
            }
            start_date
            end_date
            active
          }
        }
        notes {
          id
          content
          user {
            id
            email
            full_name
          }
          created_at
        }
        granted_mail_permissions {
          id
          title
        }
      }
    }
  }
`);
